var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.prequel)?_c('div',{staticClass:"source"},[_vm._v("Sequel to "+_vm._s(_vm.prequel))]):(_vm.media.source)?_c('div',{staticClass:"source"},[_vm._v("Source • "+_vm._s(_vm._f("capitalize")(_vm.media.source)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }